import { render } from "./Rodape.vue?vue&type=template&id=0c7f846b"
import script from "./Rodape.vue?vue&type=script&lang=js"
export * from "./Rodape.vue?vue&type=script&lang=js"

import "./Rodape.vue?vue&type=style&index=0&id=0c7f846b&lang=css"
script.render = render

export default script